export default __webpack_public_path__ + "static/story1-55504b43861beddb833f912b23732a34.png";